// src/enums/contactColumns.ts

export enum ContactColumn {
  COMPANY_NAME = 'company_name',
  CONTACTS_CUSTOMER_UNIQUE_IDENTIFICATION_NUMBER = 'contacts_customer_unique_identification_number',
  REGION_NAME = 'region__name',        
  PHONE = 'phone',
  EMAIL = 'email',
  TYPE_NAME = 'type__name',            
  INDUSTRY_NAME = 'industry__name', 
}

// Column display names mapping (for UI display - these remain user-friendly)
export const ContactColumnLabels: Record<ContactColumn, string> = {
  [ContactColumn.COMPANY_NAME]: 'Company',
  [ContactColumn.CONTACTS_CUSTOMER_UNIQUE_IDENTIFICATION_NUMBER]: 'CUI No',
  [ContactColumn.REGION_NAME]: 'Region',
  [ContactColumn.PHONE]: 'Contact',
  [ContactColumn.EMAIL]: 'Email',
  [ContactColumn.TYPE_NAME]: 'Type',
  [ContactColumn.INDUSTRY_NAME]: 'Industry',
};

// All columns array for iteration
export const ALL_CONTACT_COLUMNS = Object.values(ContactColumn);

// Default selected columns (all true)
export const getDefaultContactSelectedColumns = () => ({
  [ContactColumn.COMPANY_NAME]: true,
  [ContactColumn.CONTACTS_CUSTOMER_UNIQUE_IDENTIFICATION_NUMBER]: true,
  [ContactColumn.REGION_NAME]: true,
  [ContactColumn.PHONE]: true,
  [ContactColumn.EMAIL]: true,
  [ContactColumn.TYPE_NAME]: true,
  [ContactColumn.INDUSTRY_NAME]: true,
});